import Config from "./global/Config"
import $ from "jquery"
import { isMobileDevice, getInternetExplorerVersion } from "./utils/helper"
import AnchorLink from "./utils/AnchorLink"
import "./utils/typo3-SpamProtectedEmails.js"

import DynamicModuleLoader from "./global/DynamicModuleLoader"
import DynamicExternalModuleLoader from "./global/DynamicExternalModuleLoader"

class Main {
	constructor() {
		this.setGlobalVars()
		this.setWebpackPublicPath()
		this._init()
	}

	_init() {
		$(document.body).removeClass("no-js")

		if (isMobileDevice()) {
			$(document.body).addClass("is-mobile")
		}

		if (getInternetExplorerVersion() === 11) {
			$(document.body).addClass("is-ie-11")
		}

		// check if webp images ara supportet, if not show fallback (for IE11 and Safari)
		var webP = new Image()
		webP.onload = webP.onerror = () => {
			if (webP.height !== 2) {
				$(document)
					.find("img[data-srcfallback]")
					.each(function () {
						$(this).attr("src", $(this).attr("data-srcfallback"))
					})
			}
		}
		webP.src =
			"data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA"

		// check if object-fit is supportet, if not show fallback
		if ("objectFit" in document.documentElement.style === false) {
			$(".bb-image.needs-object-fit-fallback").each((index, elem) => {
				const $image = $(elem).find("img")

				$image.on("load", () => {
					elem.style.backgroundImage =
						'url("' + ($image[0].currentSrc || $image[0].src).replace(/"/g, '\\"') + '")'
					$(elem).addClass("show-object-fit-fallback")
				})
			})
		}

		//some forms were lazy loaded, make sure that form component is loaded in this case
		$("body").on("bb-form-items-changed", () => {
			DynamicModuleLoader.load($("form").length, DynamicModuleLoader.modules.formComponent)
		})

		this.dynamicLoad()
	}

	dynamicLoad() {
		DynamicModuleLoader.load(Config.debug, DynamicModuleLoader.modules.versionDisplay)
		DynamicModuleLoader.load($("[data-fancybox]").length, DynamicModuleLoader.modules.lightboxComponent)
		DynamicModuleLoader.load($("form").length, DynamicModuleLoader.modules.formComponent)
		DynamicModuleLoader.load(
			$("[data-repeatable-container][data-is-root]").length,
			DynamicModuleLoader.modules.formRepeatable
		)
		DynamicModuleLoader.load($(".bb-accordion").length, DynamicModuleLoader.modules.accordionComponent)
		DynamicModuleLoader.load($(".bb-breadcrumb").length, DynamicModuleLoader.modules.breadcrumbComponent)
		DynamicModuleLoader.load($(".bb-contact-persons").length, DynamicModuleLoader.modules.contactPersonsComponent)
		DynamicModuleLoader.load($(".bb-faq").length, DynamicModuleLoader.modules.faqComponent, (Component) => {
			document.querySelectorAll(".bb-faq").forEach((item) => {
				new Component(item)
			})
		})
		DynamicModuleLoader.load($(".bb-gallery").length, DynamicModuleLoader.modules.galleryComponent)
		DynamicModuleLoader.load($(".bb-header").length, DynamicModuleLoader.modules.headerComponent)
		DynamicModuleLoader.load($(".bb-jobsuche").length, DynamicModuleLoader.modules.jobsuche)
		DynamicModuleLoader.load($(".bb-medienportal").length, DynamicModuleLoader.modules.medienportalComponent)
		DynamicModuleLoader.load($(".bb-news-search").length, DynamicModuleLoader.modules.newsSearchComponent)
		DynamicModuleLoader.load($(".bb-overlay").length, DynamicModuleLoader.modules.overlayComponent)
		DynamicModuleLoader.load($(".bb-search").length, DynamicModuleLoader.modules.searchComponent)
		DynamicModuleLoader.load(
			$(".bb-seminar-registration").length,
			DynamicModuleLoader.modules.seminarRegistrationComponent
		)
		DynamicModuleLoader.load($(".bb-service-panel").length, DynamicModuleLoader.modules.servicePanelComponent)
		DynamicModuleLoader.load($(".bb-slider-container").length, DynamicModuleLoader.modules.sliderContainerComponent)
		DynamicModuleLoader.load($(".bb-tabs").length, DynamicModuleLoader.modules.tabsComponent)
		DynamicModuleLoader.load(
			$(".bb-teaser-managing-director").length,
			DynamicModuleLoader.modules.teaserManagingDirectorComponent
		)
		DynamicModuleLoader.load(
			$(".bb-teaser-newsletter").length,
			DynamicModuleLoader.modules.teaserNewsletterComponent
		)
		DynamicModuleLoader.load($(".bb-tooltip").length, DynamicModuleLoader.modules.tooltipComponent)
		DynamicModuleLoader.load(
			$(".bb-youtube-video").length,
			DynamicModuleLoader.modules.youtubeVideoComponent,
			(youtubeVideoComponent) => {
				this.youtubeVideoComponent = youtubeVideoComponent
			}
		)

		// 	DynamicModuleLoader.load($('.bb-alert-ticker').length, DynamicModuleLoader.modules.alertTickerComponent)
		// 	DynamicModuleLoader.load($('.bb-inputfield-zipcode-autocomplete').length, DynamicModuleLoader.modules.inputfieldZipcodeAutocompleteComponent)
		// 	DynamicModuleLoader.load($('.bb-teaser-slider').length, DynamicModuleLoader.modules.teaserSliderComponent)
		// 	DynamicModuleLoader.load($('#bb-banner').length, DynamicModuleLoader.modules.bannerComponent)
		// 	DynamicModuleLoader.load($('.bb-text-content-slider').length, DynamicModuleLoader.modules.textContentSliderComponent)

		Config.module.external.forEach((item) => {
			DynamicExternalModuleLoader.load($(item.selector).length, item.js, item.css)
		})
	}

	/**
	 * set variable in window scope
	 */
	setGlobalVars() {
		window.$ = window.jQuery = $
	}

	/**
	 * Change webpacks publicPath on the fly
	 */
	setWebpackPublicPath() {
		if (Config.publicPath) {
			__webpack_public_path__ = Config.publicPath
		}
	}

	/**
	 * Google Maps Callback:
	 * initMap() from Maps2 Extension
	 * hide Controls
	 */
	initMap() {
		window.initMap()
		$("form.txMaps2Form").hide()
	}
}

$(() => {
	window.bbMain = new Main()
})

$(window).on("load", () => {
	window.setTimeout(() => {
		new AnchorLink()
	}, 10)
})

if (window.location.hash) {
	window.scroll(0, 0)
}
